// extracted by mini-css-extract-plugin
module.exports = {"item":"requisites_item__3UdfK","heading":"requisites_heading__3YuwN","main":"requisites_main__33hv_"};